export const onEnterOrEscapeKeyDown = (event: React.KeyboardEvent) => {
  event.stopPropagation();
  return event.keyCode === 13 || event.key === 'Enter' || event.keyCode === 27
    ? (event.target as HTMLElement).click()
    : null;
};

export const stopPropagationAccessibilityBehavior = (
  event: React.KeyboardEvent
) => {
  if (event.key === 'Tab') {
    event.stopPropagation();
  }
};
